import { useFormikContext } from 'formik'

import { useInlineNotifications } from '../../../../hooks'
import { FormBody, useFormValidationErrorsNotification } from '../../../Form'
import { SettingsNavigationGuard } from '../../SettingsNavigationGuard'
import { SettingsSection } from '../../SettingsSection'
import { SettingsFormSectionButtons } from '../SettingsFormSectionButtons'

import * as styles from './SettingsFormSectionContent.module.css'

function SettingsFormSectionContent({
  Buttons = SettingsFormSectionButtons,
  Guard = SettingsNavigationGuard,
  bodyClassName = styles.body,
  buttonsProps,
  children,
  className,
  descriptionKey,
  guardProps,
  qaName,
  saveIgnoredFieldNames,
  titleKey,
}) {
  const { dirty } = useFormikContext()

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  useFormValidationErrorsNotification({
    onRemoveNotification: handleRemoveNotification,
    onSetNotification: handleAddNotification,
  })

  return (
    <SettingsSection
      Buttons={Buttons}
      buttonsProps={{ ...buttonsProps, saveIgnoredFieldNames }}
      className={className}
      descriptionKey={descriptionKey}
      qaName={qaName}
      titleKey={titleKey}
    >
      <Guard {...guardProps} dirty={dirty} />
      <FormBody
        Actions={null}
        className={bodyClassName}
        headerProps={{ notifications }}
      >
        {children}
      </FormBody>
    </SettingsSection>
  )
}

export default SettingsFormSectionContent
